import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaShieldAlt, FaEnvelope, FaLock, FaMobileAlt } from 'react-icons/fa';

function LoginPage() {
  const navigate = useNavigate();
  const { login, verifyTotp } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [pendingToken, setPendingToken] = useState(null);
  const [totpCode, setTotpCode] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.email, formData.password);

    if (result.success && result.needsTotp) {
      setPendingToken(result.pendingToken);
      setLoading(false);
      return;
    }

    if (result.success) {
      navigate('/dashboard');
    } else {
      const isBlocked = result.error?.includes('15 dəqiqə');
      setError(result.error || 'Giriş uğursuz oldu');
      if (isBlocked) setLoading(true); // formu deaktiv et
    }

    setLoading(false);
  };

  const handleTotpSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await verifyTotp(pendingToken, totpCode);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error || 'Kod səhvdir');
    }
    setLoading(false);
  };

  if (pendingToken) {
    return (
      <div style={styles.container}>
        <div style={styles.loginBox}>
          <div style={styles.logoSection}>
            <FaMobileAlt size={50} color="#FF6B35" />
            <h1 style={styles.title}>2 Addımlı Doğrulama</h1>
            <p style={styles.subtitle}>Authenticator app-dakı 6 rəqəmli kodu daxil edin</p>
          </div>

          <form onSubmit={handleTotpSubmit} style={styles.form}>
            <div style={styles.inputGroup}>
              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                placeholder="000000"
                value={totpCode}
                onChange={(e) => setTotpCode(e.target.value.replace(/\D/g, ''))}
                required
                autoFocus
                style={{ ...styles.input, paddingLeft: 15, textAlign: 'center', fontSize: 24, letterSpacing: 6 }}
              />
            </div>

            {error && <div style={styles.error}>{error}</div>}

            <button type="submit" disabled={loading || totpCode.length !== 6} style={styles.button}>
              {loading ? 'Yoxlanılır...' : 'Təsdiqlə'}
            </button>

            <button
              type="button"
              onClick={() => { setPendingToken(null); setTotpCode(''); setError(''); }}
              style={{ background: 'none', border: 'none', color: '#999', fontSize: 13, marginTop: 10, cursor: 'pointer' }}
            >
              ← Geri qayıt
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.loginBox}>
        {/* Logo */}
        <div style={styles.logoSection}>
          <FaShieldAlt size={50} color="#FF6B35" />
          <h1 style={styles.title}>GastroQuest</h1>
          <p style={styles.subtitle}>Super Admin Panel</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={styles.form}>
          {/* Email */}
          <div style={styles.inputGroup}>
            <FaEnvelope style={styles.icon} />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          {/* Password */}
          <div style={styles.inputGroup}>
            <FaLock style={styles.icon} />
            <input
              type="password"
              name="password"
              placeholder="Şifrə"
              value={formData.password}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          {/* Error */}
          {error && <div style={styles.error}>{error}</div>}

          {/* Submit */}
          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Giriş edilir...' : 'Daxil Ol'}
          </button>
        </form>

        {/* Footer */}
        <div style={styles.footer}>
          <p style={styles.footerText}>🛡️ Secure Admin Access Only</p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  loginBox: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '40px',
    width: '100%',
    maxWidth: '450px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  },
  logoSection: {
    textAlign: 'center',
    marginBottom: '30px',
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    marginTop: '15px',
    marginBottom: '5px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#666',
    fontWeight: '500',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  inputGroup: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    position: 'absolute',
    left: '15px',
    color: '#999',
    fontSize: '18px',
  },
  input: {
    width: '100%',
    padding: '15px 15px 15px 50px',
    fontSize: '16px',
    border: '2px solid #E0E0E0',
    borderRadius: '10px',
    outline: 'none',
    transition: 'all 0.3s',
  },
  button: {
    width: '100%',
    padding: '15px',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#FF6B35',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.3s',
    marginTop: '10px',
  },
  error: {
    padding: '12px',
    backgroundColor: '#FFEBEE',
    color: '#C62828',
    borderRadius: '8px',
    fontSize: '14px',
    textAlign: 'center',
  },
  footer: {
    marginTop: '30px',
    textAlign: 'center',
  },
  footerText: {
    fontSize: '13px',
    color: '#999',
  },
};

export default LoginPage;